<template>
  <list-table
    :url="url"
    title="تعداد تراکنش های هر درگاه و کارمزد هایش"
    :fields="fields"
    :params="params"
    :excelroute="true"
  ></list-table>
</template>
<script>
import TableShowData from "../../components/table";
export default {
  name: "CalcIncome",
  data() {
    return {
      url: "transactionSummery",
      fields: [
          { key: "website_name", label: "نام وبسایت" },
          { key: "moneytype", label: "واحد پولی" },
          { key: "count", label: "تعداد تراکنش ها" },
          { key: "amount", label: "مجموع کارمزد تراکنش ها",formatter(value,key,item){return Number(value?value:0).toLocaleString()} },
          { key: "SumCost", label: "مجموع مبلغ تراکنش ها",formatter(value,key,item){return Number(parseInt(value)).toLocaleString()} },
          { key: "ShouldBe", label: "میزان کارمزد",formatter(value,key,item){return Number(parseInt(value)).toLocaleString()} },
          ],
      params: [
          {field:"datefrom" , type:"date-picker" , label:"از تاریخ"},
          {field:"dateto" , type:"date-picker" , label:"تا تاریخ"}
      ],
    };
  },
  components: {
    "list-table": TableShowData,
  },
};
</script>